import { all, put, call, takeEvery, select, take } from 'redux-saga/effects'
import moment from 'moment'
import { eventChannel, END } from 'redux-saga'
import NotificationActions from './actions'
import {
  getNotifications,
  notificationSeen,
  notificationSeenAll,
  notificationsSetState as setState,
  convertTimeOffset,
} from '../actions'

const getUser = (state) => state.user
const getClinic = (state) => state.clinic
const getDevice = (state) => state.device
const getStateNotifications = (state) => state.notifications

function countdown(secs) {
  return eventChannel((emitter) => {
    const iv = setInterval(() => {
      secs -= 1
      if (secs > 0) {
        emitter(secs)
      } else {
        // this causes the channel to close
        emitter(END)
      }
    }, 1000)
    // The subscriber must return an unsubscribe function
    return () => {
      clearInterval(iv)
    }
  })
}

export function* GET_NOTIFICATIONS({ payload }) {
  yield put(setState({ loading: true }))
  let { notificationsList } = yield select(getStateNotifications)

  const { role, details } = yield select(getUser)
  if (Object.keys(details).length === 0) {
    yield put(setState({ loading: false, notificationsList: [] }))
    try {
      while (true) {
        yield take(yield call(countdown, 60))
      }
    } finally {
      yield call(GET_NOTIFICATIONS, { payload: {} })
    }
  }
  let data = payload
  if (Object.keys(data).length === 0) {
    data = {}
    if (role === 'Superadmin') {
      data.user_type = 'sa'
    }
    if (notificationsList.length > 0) {
      data.id = notificationsList[notificationsList.length - 1].id
        ? notificationsList[notificationsList.length - 1].id
        : null
    }
  }

  const tempNotificationsList = yield call(getNotifications, data)
  notificationsList = [...notificationsList, ...tempNotificationsList]
  yield put(setState({ loading: false, notificationsList }))
  try {
    while (true) {
      yield take(yield call(countdown, 60))
    }
  } finally {
    yield call(GET_NOTIFICATIONS, { payload: {} })
  }
}

export const modityNotificationArray = (newArra) => {
  newArra = newArra.map((item) => {
    const newObj = item.extra_detail ? JSON.parse(item.extra_detail) : {}
    if (Object.keys(newObj).length > 0) {
      if (newObj.patient_id) newObj.patient_id = newObj.patient_id
      else newObj.patient_id = ''

      if (newObj.alert === '') {
        newObj.alert = newObj.rr > 30 ? 'danger' : 'warning'
      } else newObj.alert = 'default'

      if (newObj.device_id && newObj.patient_id && newObj.patient_id !== 'Unknown')
        newObj.link = `/patient/profile/${newObj.patient_id}/${newObj.device_id}`
      else newObj.link = 'empty'
    } else {
      newObj.patient_id = ''
      newObj.alert = 'default'
      newObj.link = 'empty'
    }
    item.extra_detail = newObj
    return item
  })

  return newArra
}

export const modityNotificationItem = (item) => {
  const newObj = item.extra_detail ? item.extra_detail : {}
  if (Object.keys(newObj).length > 0) {
    if (newObj.patient_id) newObj.patient_id = newObj.patient_id
    else newObj.patient_id = ''

    if (newObj.alert === '') {
      newObj.alert = newObj.rr > 30 ? 'danger' : 'warning'
    } else newObj.alert = 'default'

    if (newObj.device_id && newObj.patient_id && newObj.patient_id !== 'Unknown')
      newObj.link = `/patient/profile/${newObj.patient_id}/${newObj.device_id}`
    else newObj.link = 'empty'
  } else {
    newObj.patient_id = ''
    newObj.alert = 'default'
    newObj.link = 'empty'
  }
  item.extra_detail = newObj
  return item
}

export function* NOTIFICATION_SEEN({ payload }) {
  const { item } = payload
  yield call(notificationSeen, item)
  yield call(GET_RR_NOTIFICATIONS, { payload: {} })
}

export function* NOTIFICATION_READ_ALL({ payload }) {
  const { userClinic } = yield select(getClinic)
  payload.clinic_id = userClinic.id
  yield call(notificationSeenAll, payload)
  yield call(GET_RR_NOTIFICATIONS, { payload: {} })
}

export function* GET_RR_NOTIFICATIONS({ payload }) {
  window.log('notification fetch')
  const { userClinic } = yield select(getClinic)
  payload.notif_cat = 'RR'
  payload.clinic_id = userClinic.id
  const { inventoryListingDevices } = yield select(getDevice)
  yield put(setState({ loading: true }))
  window.log('payload', payload)
  let notificationsList = yield call(getNotifications, payload)
  payload.seen = 0
  let topBarNotifications = yield call(getNotifications, payload)

  notificationsList = modityNotificationArray(notificationsList)
  topBarNotifications = modityNotificationArray(topBarNotifications)
  yield put(
    setState({
      loading: false,
      notificationsList,
      topBarNotifications,
      inventoryDevices: inventoryListingDevices.data ? inventoryListingDevices.data : [],
    }),
  )
}

function getoffSet(dateTime) {
  const offset = new Date().getTimezoneOffset()
  let offsetToCal = offset / 60
  if (offset < 0) {
    offsetToCal = offset / -60
  }
  return convertTimeOffset(dateTime, offsetToCal, 'YYYY-MM-DD HH:mm:ss')
}

export function* GENERATE_NOTIFICATION({ payload }) {
  // window.log('function reached last notification')
  const { extra_detail: extraDetail } = payload
  const { patient_id: patientId } = extraDetail
  extraDetail.alert = 'warning'
  if (extraDetail.rr <= 12) {
    payload.title = 'Low Respiratory'
    extraDetail.alert = 'warning'
  }
  if (extraDetail.rr >= 22) {
    payload.title = 'High Respiratory'
    extraDetail.alert = 'warning'
  }
  if (extraDetail.rr > 30) {
    payload.title = 'Extremely High Respiratory'
    extraDetail.alert = 'danger'
  }

  const { notificationsList } = yield select(getStateNotifications)
  const [lastTempNotificationOfPatient] = notificationsList.filter(
    (val) => val.extra_detail.patient_id === patientId,
  )
  const now = moment(new Date())
  const end = lastTempNotificationOfPatient
    ? moment(getoffSet(lastTempNotificationOfPatient.created_at))
    : moment()

  if (patientId === lastTempNotificationOfPatient.extra_detail.patient_id) {
    if (moment.duration(now.diff(end)).asMinutes() > 1) {
      yield call(GET_RR_NOTIFICATIONS, { payload: {} })
    }
  } else {
    yield call(GET_RR_NOTIFICATIONS, { payload: {} })
  }
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([
    takeEvery(NotificationActions.GET_NOTIFICATIONS, GET_NOTIFICATIONS),
    takeEvery(NotificationActions.GENERATE_NOTIFICATION, GENERATE_NOTIFICATION),
    takeEvery(NotificationActions.GET_RR_NOTIFICATIONS, GET_RR_NOTIFICATIONS),
    takeEvery(NotificationActions.NOTIFICATION_SEEN, NOTIFICATION_SEEN),
    takeEvery(NotificationActions.NOTIFICATION_READ_ALL, NOTIFICATION_READ_ALL),
    call(GET_NOTIFICATIONS, { payload: {} }),
  ])
}
